import { fetchApi } from '@/config/axiosSetting';
import {
  GetInitialVisitSingleAccessoryQueryParamsType,
  GetInitialVisitSingleAccessoryQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitSingleAccessory/getInitialVisitSingleAccessoryQuery.type';

export const getInitialVisitSingleAccessoryFunction = (
  params: GetInitialVisitSingleAccessoryQueryParamsType,
): Promise<GetInitialVisitSingleAccessoryQueryResponseType> => {
  return fetchApi.get(`/initial/reports/${203967}/accessory/get/`, {
    params,
  });
};
